/**
 *    @author: Andrew Sheen
 *    @since:  2020-10-30
 */

import { Component, EventEmitter,Input, Output,ElementRef, OnInit,AfterViewInit } from '@angular/core';
import { LayoutBaseComponent } from '../layout-base.component';

@Component({
  selector: 'accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.less']
})

export class AccordionComponent extends LayoutBaseComponent implements OnInit,AfterViewInit  {

        @Input() hidden:boolean;
        @Input('header') title2: string;
        icon:string = "+";

        private opened:boolean = false;
        get open():boolean {
              return this.opened;
        }

        @Input('open')  set  open(value:boolean) {
                this.opened = value;
                if (!this.headDiv) return;
                if ( !this.opened ) { 
                      this.icon = "+"; 
                      this.headDiv.classList.remove("accord-close");
                      this.headDiv.classList.add("accord-open");
                      this.headDiv.setAttribute("aria-expanded", "false");
                }
                else  { 
                      this.icon = "-"; 
                      this.headDiv.classList.remove("accord-open");
                      this.headDiv.classList.add("accord-close");
                      this.headDiv.setAttribute("aria-expanded", "true");
                }
        }

        @Output("openChange") openChange = new EventEmitter<boolean>();

        public close() {
               if ( this.opened ) this.opened = false;
        }

        headDiv:any;

        constructor(private elRef:ElementRef) {   
               super(); 
               this.inputStyle = "background-color: #fdfdfd; padding: 0.5em 0 0.6em 0.5em; width:100%; margin: 0 0 1em 0.3em"
               this.label_class = "accord_width";
        }  

        ngOnInit(): void {
               if ( !this.label ) this.label = this.title2;
               this.headDiv = this.elRef.nativeElement.querySelector('.accord-head');
               if ( this.opened ) this.open = this.opened;
        }

        ngAfterViewInit() {
               super.layoutFromViewInit(this.headDiv.parentElement);
        }

        public get className():string {
            return this.class_name;
        }

        public get inputClass():string {
               return "accord-body acc-size " + this.input_class;
        }

        public get labelClass():string {
               return this.label_class;
        }
        
        public onClick(event) {
               this.open = !this.opened; 
               let  content  = this.elRef.nativeElement.querySelector('.'+"accordion-inner");
               setTimeout(function(){ 
                  content.scrollIntoView({behavior: "smooth"});
                  content.focus();
               }, 200);
               this.openChange.emit(this.opened);
               if ( event ) event.stopPropagation();
        }

        public keyPress(event:any) {
               if ( event.keyCode == 13 ) {
                    this.onClick(null);        
               }
        }
}
